var _path, _circle, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35112 11.8121C3.23374 11.1959 3.70615 10.625 4.33346 10.625H5.13083C5.61096 10.625 6.02333 10.9662 6.11317 11.4379L7.14888 16.8754C7.26626 17.4916 6.79385 18.0625 6.16654 18.0625H5.36917C4.88904 18.0625 4.47667 17.7213 4.38683 17.2496L3.35112 11.8121Z",
    fill: "white",
    stroke: "#1C1D1F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.875,
    cy: 8.5,
    r: 2.125,
    fill: "#FFD599",
    stroke: "#1C1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.5C1 6.73959 2.42709 5.3125 4.1875 5.3125H9.5C11.2604 5.3125 12.6875 6.73959 12.6875 8.5C12.6875 10.2604 11.2604 11.6875 9.5 11.6875H7.375H4.1875C2.42709 11.6875 1 10.2604 1 8.5Z",
    fill: "white",
    stroke: "#1C1D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 5.3125V11.6875",
    stroke: "#1C1D1F",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 5.82712C8.4375 5.50417 8.59347 5.2011 8.85626 5.01338L14.2938 1.12945C14.9556 0.656692 15.875 1.12982 15.875 1.94319V15.0568C15.875 15.8702 14.9556 16.3433 14.2938 15.8705L8.85626 11.9866C8.59347 11.7989 8.4375 11.4958 8.4375 11.1729V5.82712Z",
    fill: "#FF8D00",
    stroke: "#1C1D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.eebc51f7791b718481b970293c5edd3d.svg";
export { ForwardRef as ReactComponent };